import React from 'react';
import classNames from 'classnames';
import { useRouter } from 'next/router';

import { useIsCabinet } from '../../../hooks/useCabinet';

import styles from './OwnPhoneInput.module.scss';

const SinglePhoneInput = ({ value, focus, inputClass, ...restProps }) => {
  const router = useRouter();
  const inputRef = React.useRef(null);
  const isCabinet = useIsCabinet();

  React.useEffect(() => {
    if (router.isReady && focus) inputRef.current.focus();
  }, [router.isReady, focus]);

  return (
    <div
      className={classNames([
        styles.inputContainer,
        { [styles.active]: !!value },
        { [styles.cabinetInput]: isCabinet },
      ])}
      itemScope
      itemType='https://schema.org/Thing'
    >
      <input
        ref={inputRef}
        autoComplete='off'
        type={'number'}
        maxLength='1'
        value={value || ''}
        className={classNames([styles.input, inputClass])}
        aria-label={value}
        {...restProps}
      />
    </div>
  );
};

export default SinglePhoneInput;
